import TooltipItem from './tooltip-item.component';
export default TooltipItem;
